<template viewBox="0 0 24 24">
  <g>
    <path  d="M7.132,9.42A12.634,12.634,0,0,1,4.494,5.611a.749.749,0,0,1,.166-.827l.819-.818A1.53,1.53,0,0,0,5.564,1.76L4.39.586a2,2,0,0,0-2.828,0L.91,1.238a3.194,3.194,0,0,0-.85,2.87,15.715,15.715,0,0,0,4.461,7.923,15.715,15.715,0,0,0,7.923,4.461,3.194,3.194,0,0,0,2.87-.85l.651-.651a2,2,0,0,0,0-2.828L14.792,10.99a1.5,1.5,0,0,0-2.121,0l-.9.9a.749.749,0,0,1-.827.166A12.66,12.66,0,0,1,7.132,9.42Z" transform="translate(3.724 3.724)" fill="none" stroke="#0d5740" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/>
    <path  d="M0,0H24V24H0Z" fill="none"/>
  </g>
</template>

<script>
  export default {
    name: "telephone"
  }
</script>

<style scoped>

</style>
